import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createI18n } from "vue-i18n";


const messages = {
    de: {
      message: {
        applynow: "Jetzt bewerben!",
        downloadjobaspdf: "Job als PDF herunterladen",
        interestedQ: "Interessiert?",
        yourTasks: "Ihre Aufgaben",
        yourProfile: "Ihr Profil",
        yourContactperson: "Ihr Ansprechpartner",
        gotolinkedinprofile: "Zum LinkedIn Profil",
        benefitsloxone: "Benefits bei Loxone",
        weoffer: "Wir bieten",
        location: "Standort",
        application: "Bewerbung abgesendet - so geht's weiter",
        similarjobs: "Ähnliche Jobs",
        recommendjob: "Job weiterempfehlen",
        showonmap: "Auf Karte anzeigen",
        moreaboutLoxone: "Mehr über Loxone",
        weofferText: "Wir bieten Ihnen die Möglichkeit, aktiv zur Entwicklung von Loxone am (inter)nationalen Markt beizutragen. Gemeinsam machen wir mit intelligenter Gebäudeautomatisierung die Welt ein Stück energieeffizienter und nachhaltiger. Einzigartige, spannende und abwechslungsreiche Aufgaben & Projekte ermöglichen Ihnen ungeahnte persönliche und fachliche Möglichkeiten zu entfalten. Es erwartet Sie ein engagiertes Team aus vielen Top-Performern. Wir sind stolz auf unsere Unternehmenskultur, die sich durch offene und transparente Kommunikation auszeichnet. Darüber hinaus bieten wir flexible Arbeitszeiten und ermöglichen Ihnen so eine gute Work-Life-Balance.",
        applicationSteps: ["Telefoninterview","Persönliches Gespräch", "Arbeitsprobe", "Gespräch mit Geschäftsführer"],
        applicationText: "Innerhalb von 3 Werktagen erhalten Sie von uns eine Rückmeldung auf Ihre Bewerbung. Wenn Sie uns mit Ihren Bewerbungsunterlagen überzeugt haben, sieht der weitere Bewerbungsprozess wie folgt aus:",
        aboutLoxone: "<p>Loxone ermöglicht die einfache Steuerung und intelligente Automatisierung von Eigenheimen, Hotels und Wohnbau sowie Gewerbeobjekten und Spezialanwendungen. Der Miniserver als zentrales Gehirn, dient dazu als Herzstück jeder Installation. Von Profis für Profis! Installiert vom Elektrofachbetrieb sind unsere Produkte Problemlöser, Komfortverbesserer und Energiemanager zugleich. <br><br>Loxone sucht weltweit Top-Performer aus den unterschiedlichsten Bereichen, die mit intelligenter Automatisierung die Welt täglich ein Stück nachhaltiger und energieeffizienter machen wollen. Was uns verbindet, ist die Begeisterung für intelligente Gebäudeautomatisierung und die Leidenschaft für den eigenen Job.</p>",
        firstname: "Vorname",
        lastname: "Nachname",
        email: "Email",
        phone: "Telefon",
        pleaseSelect: "Bitte wählen",
        dragDropFiles: "Ziehe Dateien hier her oder",
        chooseFiles: "Wähle Dateien aus",
        acceptedFiles: "Akzeptierte Dateitypen: pdf, zip, rar, doc, docx, jpg, jpeg, png, gif, Max. Dateigröße: 15 MB, Max. Dateien: 5.",
        perFileUpload: "Per Datei-Upload",
        perEmail: "Per E-mail",
        perOneClick: "Per 1-Click (LinkedIn / Xing / Github",
        female: "Frau",
        male: "Herr",
        sendApplication: "Bewerbung absenden",
        maxCounfOfFilesPassed: "Maximale Anzahl an Dateien überschritten",
        sendApplicationConsisting: "Senden Sie uns Ihre Bewerbungsunterlagen bestehend aus:",
        applicationFiles: ["Bewerbungsschreiben","Lebenslauf","Abschluss- und","Dienstzeugnisse"],
        perMailto: "per Mail an",
        applicationSentSuccessfully: "Ihre Bewerbung wurde ergolgreich abgesendet!",
        specialBenefitForLoc: "Special Benefits bei diesem Standort"
      }
    },
    en: {
      message: {
        applynow: "Apply now!",
        downloadjobaspdf: "Download job as PDF",
        interestedQ: "Interested?",
        yourTasks: "Key Tasks",
        yourProfile: "Key Requirements",
        yourContactperson: "Your point of contact",
        gotolinkedinprofile: "LinkedIn Profile",
        benefitsloxone: "Benefits at Loxone",
        weoffer: "We offer",
        location: "Location",
        application: "Application sent – these are the next steps",
        similarjobs: "Similar jobs",
        recommendjob: "Recommend job",
        showonmap: "Show on map",
        moreaboutLoxone: "More about Loxone",
        weofferText: "Our employees are our soul. We offer attractive benefits & working conditions so that you feel completely at ease and can achieve top-level professional performance. Together we aim to make the world more energy-efficient and sustainable with intelligent building automation. Unique, exciting and varied tasks and projects enable you to develop yourself both personally and professionally. We are proud of our culture, which is characterised by open and transparent communication. In addition, we offer flexible working hours and thus enable you to achieve a good work-life balance.",
        applicationSteps: ["Telephone interview","Face-to-face interview", "Work sample", "Interview with management"],
        applicationText: "You will receive feedback on your application from us within 3 working days. If you have convinced us with your application documents, the further application process is as follows:",
        aboutLoxone: "<p>Loxone is a complete automation solution with intuitive control suitable for smart homes, commercial premises and custom applications - which is installed by skilled tradespeople.<br><br>This is a workplace for performers. We have ambitious targets and work to high standards – there’s no coasting here. We value people with ambition, insight and potential. Everyone at Loxone holds themselves to high standards and we’re looking for individuals who want to achieve and excel alongside like-minded colleagues.</p>",
        firstname: "Firstname",
        lastname: "Lastname",
        email: "Email",
        phone: "Phone",
        pleaseSelect: "Please select",
        dragDropFiles: "Drag and drop files or",
        chooseFiles: "Choose",
        acceptedFiles: "Accepted filetypes: pdf, zip, rar, doc, docx, jpg, jpeg, png, gif, Max. filesize: 15 MB, Max. number of files: 5.",
        perFileUpload: "By File-Upload",
        perEmail: "By E-mail",
        perOneClick: "By 1-Click (LinkedIn / Xing / Github",
        female: "Female",
        male: "Male",
        sendApplication: "Send application",
        maxCounfOfFilesPassed: "Maximum number of files is 5",
        sendApplicationConsisting: "Send us your application documents consisting of:",
        applicationFiles: ["letter of application","CV","graduation and","references"],
        perMailto: "by email to",
        applicationSentSuccessfully: "Your application is sent successfully!",
        specialBenefitForLoc: "Special benefits at this location"

      }
    }
  }

const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'en', 
    messages,
  })


loadFonts()

 createApp(App).use(i18n)
   .use(vuetify)
   .use(i18n)
   .mount('#app')
  
export const i18nUsage = i18n
